module.exports = __webpack_public_path__ + "img/logo.70ca8f4c.png";